import {default as isIE11} from './isIE11';
import {default as isSafari} from './isSafari';

export default {isIE11, isSafari};
